import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import { SocialNetworkIconBar } from 'components';
import styled from 'styled-components';
var Wrap = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  border: 0;\n  cursor: pointer;\n  justify-content: space-between;\n  align-content: center;\n  overflow: hidden;\n  min-height: 28px;\n"])));

function MonthEvent(props) {
  var event = props.event;
  var networks = new Set(event.post.platforms.map(function (p) {
    if (p.includes('linkedin')) {
      return 'linkedin';
    } else if (p.includes('googlemybusiness')) {
      return 'google';
    } else if (p.includes('facebookpage')) {
      return 'facebook';
    } else return p;
  }));
  if (event.title.split(' ')[0] === 'Outcome') event.title = event.title.slice(8);
  return /*#__PURE__*/React.createElement(Wrap, null, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: '0 0 65px',
      color: '#333',
      fontSize: 13
    }
  }, event.title), /*#__PURE__*/React.createElement(SocialNetworkIconBar, {
    networks: networks,
    iconSize: "small",
    style: {
      flexWrap: 'nowrap',
      overflow: 'hidden'
    }
  }));
}

export default MonthEvent;